import { type ReactElement, useMemo } from 'react';
import { type EditSubjectAreaDialogProps } from '@/types';
import { SUBJECT_AREAS_TEXT } from '@/constants/subject-area-constants';
import { SubjectAreaDialog } from './subject-area-dialog';

export const EditSubjectAreaDialog = ({
  isOpen,
  subjectAreaName,
  selectedScedCode,
  scedOptions,
  isUpdating,
  originalSubjectArea,
  isDuplicate = false,
  onSubjectAreaNameChange,
  onSelectedScedCodeChange,
  onSave,
  onClose,
}: EditSubjectAreaDialogProps): ReactElement | null => {
  const hasChanges = useMemo(() => {
    if (!originalSubjectArea) {
      return false;
    }
    const originalCode = String(originalSubjectArea.SCEDSubject);
    return subjectAreaName !== originalSubjectArea.name || selectedScedCode !== originalCode;
  }, [originalSubjectArea, subjectAreaName, selectedScedCode]);
  return (
    <SubjectAreaDialog
      isOpen={isOpen}
      modalId="edit-subject-area-modal"
      title="Edit subject area"
      subjectAreaName={subjectAreaName}
      selectedScedCode={selectedScedCode}
      scedOptions={scedOptions}
      isSubmitting={isUpdating}
      primaryText="Update"
      primaryButtonId="edit-subject-area-modal-save"
      buttonFooterId="edit-subject-area-modal-button-footer"
      cancelButtonId="edit-subject-area-modal-cancel"
      nameFieldId="edit-subject-area-name"
      scedFieldId="edit-subject-area-sced"
      isPrimaryDisabled={!hasChanges || isDuplicate}
      {...(isDuplicate ? { inlineErrorMessage: SUBJECT_AREAS_TEXT.DuplicateCombinationError } : {})}
      onSubjectAreaNameChange={onSubjectAreaNameChange}
      onSelectedScedCodeChange={onSelectedScedCodeChange}
      onPrimaryAction={onSave}
      onClose={onClose}
    />
  );
};
